import "./App.css";
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { InteractionType } from "@azure/msal-browser";
import {
  MsalProvider,
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import Routs from "./Routs";
import { reactPlugin, initializeAppInsights } from "./insightIogging";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

function App({ pca, currentAccount, accessToken }) {
  const [isInitialized, setIsInitialized] = useState(false);

  const authRequest = {
    scopes: ["User.Read", "openid", "profile"],
  };

  useEffect(() => {
    // Initialize and wait for the key to be fetched
    initializeAppInsights().finally(() => {
      setIsInitialized(true);
    });
  }, []);

  // Don't render the app until App Insights is ready (or failed softly)
  if (!isInitialized) {
    return null; // Or return <div className="loader">Loading...</div>
  }

  return (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
      >
        <AuthenticatedTemplate>
          <Routs accessToken={accessToken} currentAccount={currentAccount} />
        </AuthenticatedTemplate>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}

export default withAITracking(reactPlugin, App);
